import { HttpClient } from '@zeta-core';
import {
  APIResponse,
  IAddAdvisorUserRequest,
  IAddOnResponseData,
  IAdviceListPayload,
  IAdviceListResponse,
  IAdvisorOnboardingRequest,
  IAdvisorPlanningConfigurationRequest,
  IAdvisorPlanningConfigurationResponse,
  IBatchAssignUsersToPlanRequest,
  IBatchAssignUsersToPlanResponse,
  ICalculateMultiPlanPaymentAmountRequest,
  IBenchmarkListResponse,
  ICancelAdvisorSubscriptionRequest,
  ICancelAdvisorSubscriptionResponse,
  ICancelSubscriptionRequest,
  ICaptureFactFindSummaryNotesRequest,
  ICaptureFactFindSummaryNotesResponse,
  ICaptureInitialMeetingRequest,
  ICaptureInitialMeetingResponse,
  ICapturePlatformConfigRequest,
  ICapturePlatformConfigStatusRequest,
  ICheckProfileSetupExistsRequest,
  ICheckProfileSetupExistsResponse,
  ICheckUserOnboardedByFCARequest,
  ICheckUserOnboardedByFCAResponse,
  ICompletePaymentRequest,
  ICurrentSubscriptionResponse,
  IDocumentUploadResponse,
  IDownloadDocumentRequest,
  IDownloadDocumentResponse,
  IEmptyRequestResponse,
  IFCALookupRequest,
  IFCALookupResponse,
  IFactFindConfigResponse,
  IFetchInvoicesResponse,
  IGetAdvisorPlanAssignmentsRequest,
  IGetAdvisorPlanAssignmentsResponse,
  IGetAIConfigResponse,
  IGetAdvisorUserListRequest,
  IGetAdvisorUserListResponse,
  IGetCRMConfigResponse,
  IGetCRMOptionsResponse,
  IGetCalculatedAmountRequest,
  IGetCalculatedAmountResponse,
  IGetClientDetailsRequest,
  IGetClientDetailsResponse,
  IGetFinancialPlanningDataResponse,
  IGetMPSConfigurationResponse,
  IGetOrganisationProfileResponse,
  IGetPersonalProfileResponse,
  IGetRiskAssessmentDataResponse,
  IGetSettingsConfigResponse,
  IGetUserPlanAssignmentRequest,
  IGetUserPlanAssignmentResponse,
  IInviteBusinessRequest,
  IInvitePersonRequest,
  IInvitePersonResponse,
  IMultiPlanCalculateResponse,
  IPersonalDetailsAdvisorOnboarding,
  IPlanStatusRequest,
  IPurchaseLicensePayload,
  IPurchaseLicenseRequest,
  IPurchaseLicenseResponse,
  IQualificationsResponse,
  IQualificationsUpdateRequest,
  IQualificationsUpdateResponse,
  IRefreshPaymentRedisStatusRequest,
  IRefreshPaymentRedisStatusResponse,
  IRegisterPartnerRequest,
  IRemoveAdvisorUserRequest,
  ISaveAIConfigRequest,
  ISaveCRMConfigRequest,
  ISaveClientStatusAsArchivedRequestType,
  ISaveClientStatusAsGoneAwayRequestType,
  ISaveClientStatusAsGoneAwayResponseType,
  ISaveFinancialPlanningDataRequest,
  ISaveFinancialPlanningDataResponse,
  ISaveMPSConfigRequest,
  ISaveOrganisationProfileRequest,
  ISavePersonalProfileRequest,
  ISaveProductCategoryPayload,
  ISaveProductCategoryResponse,
  ISaveProductPayload,
  ISaveProductResponse,
  ISaveRiskAssessmentDataRequest,
  ISaveSettingsConfigRequest,
  ISaveUploadedDocumentRequest,
  ISendDocumentRequest,
  ISendDocumentRequestResponse,
  ISwitchCalculateResponse,
  ISwitchLicenseCalculateRequest,
  ISwitchLicenseCalculateResponse,
  ISwitchLicenseResponse,
  ISwitchLicensev1Request,
  IUpdateFinancialPlanningDataRequest,
  IUpdateProfileSetupAccoladesRequest,
  IUpdateProfileSetupExpertiseDetailsRequest,
  IUpdateProfileSetupExpertiseDetailsResponse,
  IUpdateProfileSetupProfileDetailsRequest,
  IUploadDocumentRequest,
  IUploadRequestedDocumentsRequest,
  IViewAddonPayload,
  IViewAdvisorBillingInvoiceResponse,
  IViewBasicPlanPayload,
  IViewBasicPlanResponse,
  IViewClientEngagementDetailsResponse,
  IViewClientEngagementResponse,
  IViewFactFindProtectionSolutionRequest,
  IViewFactFindSummaryNotesResponse,
  IViewFinancialPlanningDropdownListResponse,
  IViewInitialMeetingRequest,
  IViewInitialMeetingResponse,
  IViewPlatformConfigResponse,
  IViewPlatformDropdownListResponse,
  IViewProductConfig,
  IViewProductConfigPayload,
  IViewProfileSetupAccoladesResponse,
  IViewPlanStatusByRequestResponse,
  IViewRequestedDocumentsRequest,
  IViewRequestedDocumentsResponse,
} from '@zeta-types';
import { AxiosProgressEvent } from 'axios';
import { ADVISOR_SERVICE, STATE_SERVICE } from '../services-path';

export const AdvisorAPIs = () => {
  return {
    // profile setup
    checkProfileSetupExists: (payload: ICheckProfileSetupExistsRequest): APIResponse<ICheckProfileSetupExistsResponse> =>
      HttpClient.post(`${STATE_SERVICE}/state/instance/view`, payload),

    initiateProfileSetupJourney: (payload: IEmptyRequestResponse): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/initiate/profile/setup`, payload),

    // accolades details

    updateProfileSetupAccoladesDetails: (payload: IUpdateProfileSetupAccoladesRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/accolades/save`, payload),

    viewProfileSetupAccoladesDetails: (payload: IEmptyRequestResponse): APIResponse<IViewProfileSetupAccoladesResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/accolades/view`, payload),

    reinviteClient: (payload: IBatchReinviteClientRequest): APIResponse<IViewProfileSetupAccoladesResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/client/reinvite`, payload),

    // peronsal details
    viewProfileSetupPersonalDetails: (payload: IEmptyRequestResponse): APIResponse<IPersonalDetailsAdvisorOnboarding> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/view/profile/personal`, payload),

    updateProfileSetupProfileDetails: (payload: IUpdateProfileSetupProfileDetailsRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.upload(`${ADVISOR_SERVICE}/advisor/update/profile/personal`, payload),

    // expertise details
    viewProfileSetupExpertiseDetails: (payload: IEmptyRequestResponse): APIResponse<IUpdateProfileSetupExpertiseDetailsResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/view/profile/expertise`, payload),

    updateProfileSetupExpertiseDetails: (payload: IUpdateProfileSetupExpertiseDetailsRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/update/profile/expertise`, payload),

    advisorLookup: (payload: IFCALookupRequest): APIResponse<IFCALookupResponse> => HttpClient.post(`${ADVISOR_SERVICE}/advisor/lookup`, payload),

    advisorOnboarding: (payload: IAdvisorOnboardingRequest) => HttpClient.post(`${ADVISOR_SERVICE}/advisor/initiate/onboarding`, payload),

    profileQualificationDetails: (payload: IEmptyRequestResponse): APIResponse<IQualificationsResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/view/profile/qualification`, payload),

    profileUpdateQualificationDetails: (payload: IQualificationsUpdateRequest): APIResponse<IQualificationsUpdateResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/update/profile/qualification`, payload),

    captureInitialMeeting: (payload: ICaptureInitialMeetingRequest): APIResponse<ICaptureInitialMeetingResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/capture/initialmeeting`, payload),

    viewInitialMeeting: (payload: IViewInitialMeetingRequest): APIResponse<IViewInitialMeetingResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/view/initialmeeting`, payload),

    // Profile Set Up APIs

    inviteRetailClient: (payload: IInvitePersonRequest | IInviteBusinessRequest): APIResponse<IInvitePersonResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/retail/prospective/invite`, payload),

    getBenchMarkList: (payload: IEmptyRequestResponse): APIResponse<IBenchmarkListResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/benchmark/view`, payload),

    saveMPSConfiguration: (payload: ISaveMPSConfigRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/mps/save`, payload),

    getMPSConfiguration: (payload: IEmptyRequestResponse = {}): APIResponse<IGetMPSConfigurationResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/mps/view`, payload),

    getOrganisationProfile: (payload: IEmptyRequestResponse): APIResponse<IGetOrganisationProfileResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/view/organisation/profile`, payload),

    saveOrganisationProfile: (payload: ISaveOrganisationProfileRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/update/organisation/profile`, payload),

    getPersonalProfile: (payload: IEmptyRequestResponse): APIResponse<IGetPersonalProfileResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/view/personal/profile`, payload),

    savePersonalProfile: (payload: ISavePersonalProfileRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/update/personal/profile`, payload),

    getRiskAssessmentData: (payload: IEmptyRequestResponse): APIResponse<IGetRiskAssessmentDataResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/riskassessment/view`, payload),

    saveRiskAssessmentData: (payload: ISaveRiskAssessmentDataRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/riskassessment/save`, payload),

    getFinancialPlanningData: (payload: IEmptyRequestResponse): APIResponse<IGetFinancialPlanningDataResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/financialplanning/view`, payload),

    saveFinancialPlanningData: (payload: ISaveFinancialPlanningDataRequest): APIResponse<ISaveFinancialPlanningDataResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/financialplanning/save`, payload),

    updateFinancialPlanningData: (payload: IUpdateFinancialPlanningDataRequest): APIResponse<ISaveFinancialPlanningDataResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/financialplanning/status/update`, payload),

    saveClientStatusAsGoneAway: (payload: ISaveClientStatusAsGoneAwayRequestType): APIResponse<ISaveClientStatusAsGoneAwayResponseType> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/update/goneaway/status`, payload),

    saveClientStatusAsArchived: (payload: ISaveClientStatusAsArchivedRequestType): APIResponse<ISaveClientStatusAsGoneAwayResponseType> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/prospect/case/maintain`, payload),

    saveClientStatusAsActive: (payload: { caseID: string }): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/prospect/case/maintain`, { ...payload, clientStatus: 'Active' }),

    getSettingsConfigData: (payload: IEmptyRequestResponse): APIResponse<IGetSettingsConfigResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/email/config/view`, payload),

    saveSettingsConfigData: (payload: ISaveSettingsConfigRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/email/config/save`, payload),

    getAIConfigData: (payload: IEmptyRequestResponse): APIResponse<IGetAIConfigResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/ai/coverage/view`, payload),

    saveAIConfigData: (payload: ISaveAIConfigRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/ai/coverage/save`, payload),

    getAIDocumentConfig: (payload: { documentType: string }): APIResponse<any> => HttpClient.post(`${ADVISOR_SERVICE}/ai-document-config/get`, payload),

    updateAIDocumentConfig: (payload: {
      documentType: string;
      documentCategory?: string;
      documentCategorySlug?: string;
      displayName?: string;
      displayOrder?: number;
      customSampleData?: string;
      customRequiredFields?: { name: string; description: string; order: number }[];
      customQuestions?: string[];
    }): APIResponse<any> => HttpClient.post(`${ADVISOR_SERVICE}/ai-document-config/update`, payload),

    getCRMConfigData: (payload: IEmptyRequestResponse): APIResponse<IGetCRMConfigResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/config/crm/view`, payload),

    saveCRMConfigData: (payload: ISaveCRMConfigRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/config/crm/save`, payload),

    viewPlaformConfig: (payload: IEmptyRequestResponse): APIResponse<IViewPlatformConfigResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/platform/config/view`, payload),

    viewPlatformDropdownList: (payload: IEmptyRequestResponse): APIResponse<IViewPlatformDropdownListResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/platform/dropdown/view`, payload),

    capturePlatformConfig: (payload: ICapturePlatformConfigRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/platform/config/save`, payload),

    capturePlatformConfigStatus: (payload: ICapturePlatformConfigStatusRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/platform/config/status/save`, payload),

    viewFinancialPlanningDropdownList: (payload: IEmptyRequestResponse): APIResponse<IViewFinancialPlanningDropdownListResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/financialplanning/dropdown/view`, payload),

    // summary and notes
    // summary notes
    viewSummaryNotes: (payload: IViewFactFindProtectionSolutionRequest): APIResponse<IViewFactFindSummaryNotesResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/note/view`, payload),

    captureSummaryNotes: (payload: ICaptureFactFindSummaryNotesRequest): APIResponse<ICaptureFactFindSummaryNotesResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/note/capture`, payload),

    // check if client with FCA already exists in system
    checkUserOnboardedByFCA: (payload: ICheckUserOnboardedByFCARequest): APIResponse<ICheckUserOnboardedByFCAResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/verify/fca`, payload),

    // CLIENT PORTAL
    getClientDetailsByInvitationCode: (payload: IGetClientDetailsRequest): APIResponse<IGetClientDetailsResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/invited/info`, payload, undefined, true),

    sendDocumentRequest: (payload: ISendDocumentRequest): APIResponse<ISendDocumentRequestResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/rd/send`, payload),

    viewRequestedDocuments: (payload: IViewRequestedDocumentsRequest): APIResponse<IViewRequestedDocumentsResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/rd/view`, payload),

    uploadRequestedDocuments: (payload: IUploadRequestedDocumentsRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/rd/upload`, payload),

    getAdvisorMeetingSlots: (payload: IMeetingSlotRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/meetingtime/suggested`, payload),

    viewFactFindConfig: (payload: IEmptyRequestResponse): APIResponse<IFactFindConfigResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/ff/field/config/view`, payload),

    saveFactFindConfig: (payload: IEmptyRequestResponse): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/ff/field/config/save`, payload),

    getDocumentsPublic: (payload: { sessionToken: string }): APIResponse<IViewRequestedDocumentsResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/public/rd/view`, payload),

    uploadDocumentsPublic: (
      payload: IUploadDocumentRequest,
      onUploadProgress?: (progressEvent: AxiosProgressEvent) => void
    ): APIResponse<IDocumentUploadResponse> => HttpClient.upload(`${ADVISOR_SERVICE}/advisor/public/rd/s3/upload`, payload, { onUploadProgress }),

    saveUploadDocumentsPublic: (payload: ISaveUploadedDocumentRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/public/rd/upload`, payload),

    downloadDocumentPublic: (payload: IDownloadDocumentRequest): APIResponse<IDownloadDocumentResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/public/rd/download`, payload),

    getAdvisorPlanningConfiguration: (payload: IAdvisorPlanningConfigurationRequest): APIResponse<IAdvisorPlanningConfigurationResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/financialplanning/view`, payload),

    viewAdviceList: (payload: IAdviceListPayload): APIResponse<IAdviceListResponse> => HttpClient.post(`${ADVISOR_SERVICE}/advisor/advicetype/list`, payload),

    saveProductCategory: (payload: ISaveProductCategoryPayload): APIResponse<ISaveProductCategoryResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/config/productcategory/save`, payload),

    saveProductInsurance: (payload: ISaveProductCategoryPayload): APIResponse<ISaveProductCategoryResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/insurance/config/save`, payload),

    viewProductInsurance: (payload: ISaveProductCategoryPayload): APIResponse<ISaveProductCategoryResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/insurance/config/view`, payload),

    saveProduct: (payload: ISaveProductPayload): APIResponse<ISaveProductResponse> => HttpClient.post(`${ADVISOR_SERVICE}/advisor/product/save`, payload),

    viewProductConfig: (payload: IViewProductConfigPayload): APIResponse<IViewProductConfig> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/product/view`, payload),

    viewBasicPlan: (payload: IViewBasicPlanPayload): APIResponse<IViewBasicPlanResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/billing/view/basicplan`, payload),

    viewAddons: (payload: IViewAddonPayload): APIResponse<IAddOnResponseData> => HttpClient.post(`${ADVISOR_SERVICE}/billing/view/addon`, payload),

    purchaseLicense: (payload: IPurchaseLicenseRequest): APIResponse<IPurchaseLicenseResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/billing/purchase`, payload),
    // SET DEFAULT MEETING TYPE
    getDefaultMeetingType: (payload: IEmptyRequestResponse): APIResponse<{ defaultMeetingType: string; defaultMeetingDuration: number }> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/default/meeting/view`, payload),

    saveDefaultMeetingType: (payload: { defaultMeetingType: string; defaultMeetingDuration: number }): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/default/meeting/save`, payload),

    viewClientEngagementOptions: (payload: IEmptyRequestResponse): APIResponse<IViewClientEngagementResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/engagement/list`, payload),

    fetchInvoices: (payload: IEmptyRequestResponse): APIResponse<IViewAdvisorBillingInvoiceResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/billing/view/invoices`, payload),

    getCalculatedAmount: (payload: ICalculateMultiPlanPaymentAmountRequest): APIResponse<IMultiPlanCalculateResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/billing/payment/calculate`, payload),

    getCurrentSubscription: (payload: IEmptyRequestResponse): APIResponse<ICurrentSubscriptionResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/billing/view/subscription`, payload),

    completePurchasePayment: (payload: ICompletePaymentRequest): APIResponse<ICompleteLicensePaymentResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/billing/payment/complete`, payload),

    cancelSubscription: (payload: ICancelAdvisorSubscriptionRequest): APIResponse<ICancelAdvisorSubscriptionResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/billing/subscription/cancel`, payload),

    cancelCancellation: (payload: IEmptyRequestResponse): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/billing/subscription/reactivate`, payload),

    purchaseEnterpriseLicense: (payload: { referenceID: string }): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/billing/licence/enterprise/request`, payload),

    switchSubscriptionPlan: (payload: ISwitchLicensev1Request): APIResponse<ISwitchLicenseResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/billing/license/switch`, payload),

    switchCalculateAmount: (payload: IGetCalculatedAmountRequest): APIResponse<ISwitchCalculateResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/billing/payment/calculate`, payload),

    switchLicenseCalculateAmount: (payload: ISwitchLicenseCalculateRequest): APIResponse<ISwitchLicenseCalculateResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/billing/payment/switch/calculate`, payload),

    refreshPaymentStatus: (payload: IRefreshPaymentRedisStatusRequest): APIResponse<IRefreshPaymentRedisStatusResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/billing/payment/redis/refresh`, payload),

    viewPlanStatus: (payload: IPlanStatusRequest): APIResponse<IViewPlanStatusByRequestResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/billing/plan/status`, payload),

    batchAssignUsersToPlan: (payload: IBatchAssignUsersToPlanRequest): APIResponse<IBatchAssignUsersToPlanResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/billing/user/plan/batch-assign`, payload),

    getAdvisorPlanAssignments: (payload: IGetAdvisorPlanAssignmentsRequest): APIResponse<IGetAdvisorPlanAssignmentsResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/billing/user/plan/assignments`, payload),

    getUserPlanAssignment: (payload: IGetUserPlanAssignmentRequest): APIResponse<IGetUserPlanAssignmentResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/billing/user/plan/assignment`, payload),

    //to get planning status in client portal
    viewClientEngagementDetails: (payload: { caseID: string }): APIResponse<IViewClientEngagementDetailsResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/engagement/search`, payload),

    // register partner
    registerPartner: (payload: IRegisterPartnerRequest): APIResponse<{ id: string }> => HttpClient.post(`${ADVISOR_SERVICE}/advisor/register/partner`, payload),

    getCRMOptions: (payload: IEmptyRequestResponse): APIResponse<IGetCRMOptionsResponse> => HttpClient.post(`${ADVISOR_SERVICE}/advisor/view/crmlist`, payload),

    // advisor user access for clients

    getAdvisorUserList: (payload: IGetAdvisorUserListRequest): APIResponse<IGetAdvisorUserListResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/client-access/view`, payload),

    addAdvisorUser: (payload: IAddAdvisorUserRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/client-access/grant`, payload),

    removeAdvisorUser: (payload: IRemoveAdvisorUserRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/client-access/revoke`, payload),

    deleteFinancialPlan: (payload: { planIDs: string[] }) =>
      HttpClient.post<IEmptyRequestResponse>(`${ADVISOR_SERVICE}/advisor/financialplanning/delete`, payload),

    // Fees & Charges
    createFeeSetup: (payload: {
      advisorFee: unknown;
      advisorFeeMechanics: unknown;
      advisorFeeTrigger: unknown;
      advisorFeePayerPayment: unknown;
      advisorFeeProductLinks?: unknown[];
    }): APIResponse<IEmptyRequestResponse> => HttpClient.post(`${ADVISOR_SERVICE}/advisor/fee/setup`, payload),

    viewFeeEnums: (payload: IEmptyRequestResponse): APIResponse<any> => HttpClient.post(`${ADVISOR_SERVICE}/advisor/fee/view/enum`, payload),

    viewFeeList: (payload: unknown): APIResponse<unknown> => HttpClient.post(`${ADVISOR_SERVICE}/advisor/fee/view`, payload),

    deleteFees: (payload: { feeIDs: string[] }): APIResponse<IEmptyRequestResponse> => HttpClient.post(`${ADVISOR_SERVICE}/advisor/fee/delete`, payload),

    exportFees: (payload: unknown): APIResponse<IEmptyRequestResponse> => HttpClient.download(`${ADVISOR_SERVICE}/advisor/fee/export`, payload),

    viewFeeById: (payload: { feeID: string; fullDetail?: boolean }): APIResponse<unknown> =>
      HttpClient.post(`${ADVISOR_SERVICE}/advisor/fee/viewbyid`, payload),

    editFee: (payload: unknown): APIResponse<IEmptyRequestResponse> => HttpClient.post(`${ADVISOR_SERVICE}/advisor/fee/edit`, payload),

    getNotificationSettings: (): APIResponse<any> => HttpClient.post(`${ADVISOR_SERVICE}/billing/notification/list`, {}),
    saveNotificationSettings: ({ enabled, additionalEmails }: { enabled: boolean; additionalEmails: string[] }): APIResponse<any> =>
      HttpClient.post(`${ADVISOR_SERVICE}/billing/notification/maintain`, {
        enabled,
        additionalEmails,
      }),
  };
};
